<div class="setup-stocks-bonds">
  <div class="header">
    <div>
      <h2 class="ui-headline">{{ 'strategy.portfolio.title' | translate }}</h2>
      <ng-container *ngIf="investmentData.stock_split !== 1; else pureStocks">
        <p class="bondsExplanation">
          <span
            [innerHtml]="
              'strategy.portfolio.p1'
                | translate
                  : {
                      riskLevel: 'new_strategy.risk_screen.slider.active.' + riskName | translate | lowercase,
                      stockTarget: investmentData.stock_split | percent: '1.0-0',
                      bondTarget: 1 - investmentData.stock_split | percent: '1.0-0'
                    }
            "
          ></span>
          <app-ui-tooltip [content]="'bonds.tooltip.p' | translate" color="yellow" size="small"></app-ui-tooltip>
          <span>{{ 'strategy.portfolio.p2' | translate }}</span>
        </p>
      </ng-container>
      <ng-template #pureStocks>
        <p
          [innerHtml]="
            'strategy.portfolio.stocksOnly'
              | translate
                : {
                    riskLevel: 'new_strategy.risk_screen.slider.active.' + riskName | translate | lowercase,
                    stockTarget: investmentData.stock_split | percent: '1.0-0'
                  }
          "
        ></p>
      </ng-template>
    </div>
  </div>

  <div class="ui-section-tabs-container">
    <div class="ui-section-tabs">
      <div
        class="ui-section-tab"
        tabindex="0"
        [ngClass]="{ active: yourStocks }"
        *ngIf="investmentData.stock_split > 0"
        (keyup.enter)="changeTab('stock')"
        (click)="changeTab('stock')"
      >
        <div>
          <span class="icon-i-lightning"></span>
          <p>
            {{ 'new_strategy.portfolio_screen.tab.stocksEve2' | translate }}<span *ngIf="stocksCount"> ({{ stocksCount }})</span>
          </p>
        </div>
      </div>

      <div
        class="ui-section-tab"
        tabindex="0"
        [ngClass]="{ active: !yourStocks }"
        *ngIf="investmentData.stock_split !== 1"
        (keyup.enter)="changeTab('bond')"
        (click)="changeTab('bond')"
      >
        <div>
          <span class="icon-i-leaf"></span>
          <p>
            {{ 'new_strategy.portfolio_screen.tab.bonds' | translate }}
          </p>
        </div>
      </div>
    </div>

    <div class="ui-section-tabs-content">
      <ng-container *ngIf="yourStocks; else showBondList">
        <app-ui-info-box *ngIf="editMode" status="info">
          <p>{{ 'new_strategy.portfolio_screen.stock_ratio.weightBeforeInvestment' | translate }}</p>
        </app-ui-info-box>
        <app-ui-info-box *ngIf="currentAccount.step_status === 5 && someZeroPercentage" status="info">
          <p>{{ 'strategy.stocks.zero' | translate }}</p>
        </app-ui-info-box>
        <div *ngIf="!portfolioCompaniesList.length; else listHolder">
          <div *ngFor="let load of [].constructor(MINIMUM_COMPANIES)" class="skeleton-wrapper">
            <div class="title-holder">
              <div class="title skeleton"></div>
              <div class="img skeleton"></div>
            </div>
            <div class="button skeleton"></div>
          </div>
        </div>
        <ng-template #listHolder>
          <ng-container>
            <div class="stocks-bonds-list">
              <app-setup-portfolio-company-list
                [appLocation]="appLocation"
                [stepStatus]="currentAccount.step_status"
                [enabledActions]="false"
                [companyList]="shownCompanies"
                [selectedCompanyID]="selectedCompanyID"
                (updateCompanyDetail)="updateCompanyDetail($event)"
              ></app-setup-portfolio-company-list>
            </div>
            <div class="show-all">
              <a (click)="showAllCompanies()">
                {{ (!showAll ? 'strategy.show_more_companies' : 'strategy.show_less_companies') | translate }}
              </a>
            </div>
          </ng-container>
        </ng-template>
      </ng-container>
      <ng-template #showBondList>
        <app-ui-info-box *ngIf="editMode" status="info">
          <p>{{ 'bonds.info' | translate }}</p>
        </app-ui-info-box>
        <ng-container *ngFor="let bond of bonds">
          <div class="bond no-hover" (click)="changeSelectedBondID(bond.id)">
            <div class="country">
              <img src="{{ bond.img }}" />
              <p>
                <b>{{ 'bonds.' + bond.id + '.title' | translate }}</b>
                <span *ngIf="currentAccount.step_status === 5">{{ (1 - investmentData.stock_split) * bond.perc | translatePercent: language }}</span>
              </p>
            </div>
            <div class="bond-actions">
              <img [src]="'assets/images/icons/chevron-' + (selectedBondID === bond.id ? 'up' : 'down') + '.svg'" alt="Chevron" />
            </div>
          </div>
          <div class="bond-detail" *ngIf="selectedBondID === bond.id">
            <p [innerHTML]="'bonds.' + bond.id + '.desc' | translate"></p>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>
